/**
 * [INPUT]: 依赖 react，依赖 react-router-dom 的 Link；依赖 ../seo 的 SITE
 * [OUTPUT]: 对外提供 Footer 组件，渲染品牌标识 + 法律页路由链接 + 版权
 * [POS]: apps/web/components 的共享页脚，被 LandingPage 与 App 结果视图复用
 * [PROTOCOL]: 变更时更新本头部，然后检查 ../CLAUDE.md
 */
import { Link } from 'react-router-dom'
import { SITE } from '../seo'

export function Footer() {
  return (
    <footer className="border-t border-slate-700 bg-slate-950 py-12 mt-auto">
      <div className="max-w-6xl mx-auto px-6 text-center space-y-6">
        <div className="flex items-center justify-center gap-2">
          <div className="w-6 h-6 rounded bg-gradient-to-br from-brass to-amber flex items-center justify-center font-bold text-slate-950 text-xs">
            P
          </div>
          <span className="font-bold text-sm tracking-tight text-white">{SITE.name}</span>
        </div>

        <p className="text-slate-500 text-xs leading-relaxed max-w-2xl mx-auto">
          Disclaimer: Scores provided by this website are heuristic estimates based on 3D geometric proportions. Results are for entertainment and educational reference only. They do not constitute medical diagnosis, cosmetic surgery advice, professional employment criteria, or any form of scientific qualification.
        </p>

        <nav className="flex items-center justify-center gap-6 text-xs text-slate-400" aria-label="Legal">
          <Link to="/contact" className="hover:text-white transition duration-200">
            Contact
          </Link>
          <Link to="/terms" className="hover:text-white transition duration-200">
            Terms of service
          </Link>
          <Link to="/privacy" className="hover:text-white transition duration-200">
            Privacy
          </Link>
        </nav>

        <div className="text-[11px] text-slate-600 space-y-1">
          <div>
            <a href="https://pslanalyzer.com/" className="hover:text-slate-400 transition duration-200">
              pslanalyzer.com
            </a>
            {' · '}
            <a href={`mailto:${SITE.contactEmail}`} className="hover:text-slate-400 transition duration-200">
              {SITE.contactEmail}
            </a>
          </div>
          <div>
            &copy; {new Date().getFullYear()} {SITE.name}. Built for on-device privacy. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}